<template>
  <Loader :show="loading" v-if="loading" />
  <div class="pb-2" v-else-if="training?.id">
    <CategoryTop :breadcrumbs-parent-routes="['trainings', 'bridgestoneSchulungen']"
      :breadcrumbs-route-name="getLocalizedValue(training.title)" class="mb-3" contentClass="fix-height"
      mainClass="training-container" />
    <MDBRow>
      <MDBCol xl="7" cols="12" class="image-col">
        <img v-if="getLocalizedValue(training.poster)" :src="getImage(getLocalizedValue(training.poster))"
          :alt="getLocalizedValue(training.title)" />
      </MDBCol>
      <MDBCol xl="5" cols="12">
        <div class="textBox h-auto textBox__training">
          <div v-html="getLocalizedValue(training.title)" class="fw-bold"></div>
          <p class="fw-bold">
            {{ $t("trainings.singleLecture.index.costs") }}
          </p>
          <div v-if="trainingDetails">
            <div v-for="(trainingDetail, index) in trainingDetails" :key="index" class="pb-2">
              <div class="fw-bold pb-2">
                {{ setType(trainingDetail.b_training_type_id) }}
              </div>
              <div>
                {{
                  $t("trainings.singleLecture.index.duration", {
                    duration: getLocalizedValue(trainingDetail.duration),
                  })
                }}
              </div>
              <div v-html="$t('trainings.singleLecture.index.cost', {
                cost: setCost(trainingDetail.b_training_cost_id),
                price: getLocalizedNumber(trainingDetail.price),
                points: getLocalizedNumber(trainingDetail.price) * 4,
              })
                "></div>
              <div v-html="$t('trainings.singleLecture.index.participantsNr', {
                min: getLocalizedValue(trainingDetail.min_participant),
                max: getLocalizedValue(trainingDetail.max_participant),
              })
                "></div>
              <div v-if="getLocalizedValue(trainingDetail.extras)">
                ({{ getLocalizedValue(trainingDetail.extras) }})
              </div>
            </div>
          </div>
        </div>
      </MDBCol>
    </MDBRow>
  </div>
</template>

<script setup>
import Loader from "@/components/General/Loader/index.vue";
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import CategoryTop from "@/components/General/CategoryTop/index.vue";
import { computed } from "vue";
import { useStore } from "vuex";
import { pickTranslation } from "@/utils/pickTranslation";

const store = useStore();
const loading = computed(() => store.getters.getBTrainingLoading);

const getImage = (img) => {
  const image = img ? img : "";

  return `${image}`;
};
const training = computed(() => store.getters.getBTraining);
const trainingDetails = computed(() => store.getters.getBTrainingDetails);
const trainingCosts = computed(() => store.getters.getBTrainingCosts);
const trainingTypes = computed(() => store.getters.getBTrainingTypes);
const currentLocale = computed(() => store.getters.getCurrentLocale);

const getLocalizedValue = (value) => pickTranslation(value, currentLocale.value);

const getLocalizedNumber = (value) => {
  if (typeof value === "number") return value;
  if (typeof value === "string") return Number(value) || 0;
  return Number(getLocalizedValue(value)) || 0;
};

const setCost = (costId) => {
  const trainingCost = trainingCosts.value.find(
    (item) => item.id == costId
  );

  return trainingCost ? getLocalizedValue(trainingCost.type) : "";
};

const setType = (typeId) => {
  const trainingType = trainingTypes.value.find(
    (item) => item.id == typeId
  );

  return trainingType ? getLocalizedValue(trainingType.name) : "";
};
</script>

<style scoped lang="scss">
@import "../../../styles/_variables.scss";
@import "@/styles/training.scss";
</style>
